import { render, staticRenderFns } from "./tpcinterpretation.vue?vue&type=template&id=0c41d870&scoped=true"
import script from "./tpcinterpretation.vue?vue&type=script&lang=js"
export * from "./tpcinterpretation.vue?vue&type=script&lang=js"
import style0 from "./tpcinterpretation.vue?vue&type=style&index=0&id=0c41d870&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c41d870",
  null
  
)

export default component.exports